<template>
  <div class="h-100 px-0 mx-0 position-relative">
    <b-row class="h-100 px-0 mx-0">
      <b-col cols="2" class="d-none d-md-block px-0 bg-light border rounded-left overflow-hidden">
        <Messages />
      </b-col>
      <b-col cols="12" md="10" xl="7" class="px-0 bg-light border rounded-right overflow-hidden">
        <MessageThread />
      </b-col>
      <b-col cols="3" class="d-none d-xl-block overflow-hidden">
        <MessageDetails v-if="!isMobile"/>
      </b-col>
    </b-row>
    <transition name="enter-left">
      <Messages v-if="isMobile && showMessages" id="messages-popout"/>
    </transition>
  </div>
</template>

<script>
import Messages from '../../components/Messaging/Messages'
import MessageThread from '../../components/Messaging/MessageThread'
import MessageDetails from '../../components/Messaging/MessageDetails'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Messaging',
  components: { Messages, MessageThread, MessageDetails },
  computed: {
    ...mapGetters(['getMessages', 'getMyInfo', 'getActiveSubscription']),
    isMobile() { return window.innerWidth < 768 },
    showMessages() { return !this.$route.query.messageId && this.getMessages.length !== 1 }
  },
  methods: {
    ...mapActions(['loadMessages', 'updateUnread', 'listenForMessages', 'getMe', 'loadActiveSubscriptions', 'loadActiveUserSubscriptions']),
    showFirst() {
      const message = this.getMessages[0]
      if ((!this.$route.query.messageId && message && !this.isMobile) || this.getMessages.length === 1) {
        this.$router.push({name: 'messages', query: {messageId: message.messageId, threadId: message.threadId}})
      }
    }
  },
  mounted: async function() {
    if (!this.getMyInfo) await this.getMe()
    if (!this.getActiveSubscription) await this.loadActiveSubscriptions()
    await this.loadMessages()
    this.showFirst()
  },
  watch: {
    getMessages() {
      this.showFirst()
    }
  }
}
</script>

<style scoped>
#messages-popout {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 2;
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/app/Pages/Messaging/Messaging.vue?ed18a7fa